module.exports = __webpack_public_path__ + "media/brands/simson-8b64f589.png";